import { configureStore } from '@reduxjs/toolkit';

import rootReducer from 'selective_solder_fixtures/rootReducer';

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
